export default "/images/risk.svg?b62f1c83f354a676cab1d078e6c69d62";